import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PersonalInfo from './PersonalInfo';
import { toast } from 'sonner';
import Loading from '../components/Loading';
import { useHeader } from '@/contexts/HeaderContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Profile = ({ userId }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const { setHeaderProps } = useHeader();
  useEffect(() => {
    // restore global header for profile screen
    setHeaderProps({ title: i18n.language === 'it' ? 'Profilo' : 'Profile' });
  }, [setHeaderProps, i18n.language]);

  // removed duplicate useEffect and fetchProfile

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${API}/user/${userId}`);
        setProfile(response.data);
        // Sync language with i18n — respect localStorage preference over server
        const savedLang = localStorage.getItem('betterhusbandUserLang');
        const userLanguage = savedLang || response.data.language || i18n.language || 'en';
        if (i18n.language !== userLanguage) {
          i18n.changeLanguage(userLanguage);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [userId, i18n]);

  // Section Component
  const Section = ({ title, children }) => (
    <div className="mb-6">
      <h2 className="text-xs font-semibold text-stone-400 uppercase tracking-wider mb-2 px-1">
        {title}
      </h2>
      <div className="bg-inherit rounded-xl">
        <div className="px-4">
          {children}
        </div>
      </div>
    </div>
  );

  // Info Row Component (read-only)
  const InfoRow = ({ title, value }) => (
    <div className="py-3">
      <div className="flex-1 min-w-0">
        <p className="text-xs text-stone-500 mb-0.5">{title}</p>
        <p className="text-md font-medium text-stone-900">{value || '-'}</p>
      </div>
    </div>
  );

  // Navigable Row (with arrow)
  const NavigableRow = ({ title, description, onClick }) => (
    <button
      onClick={onClick}
      className="w-full py-3 flex items-center hover:bg-stone-50 -mx-4 px-4 rounded-full transition-colors"
    >
      <div className="flex-1 text-left min-w-0">
        <p className="text-sm font-medium text-stone-900">{title}</p>
        {description && (
          <p className="text-xs text-stone-500 mt-0.5">{description}</p>
        )}
      </div>
      <ChevronRight className="w-4 h-4 text-stone-400 flex-shrink-0" />
    </button>
  );

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center page-container" style={{ background: 'inherit' }}>
        <Loading size="hundred" message={null} />
      </div>
    );
  }

  // simply render the PersonalInfo component with data
  return <PersonalInfo profile={profile} />;

};

export default Profile;
